module.exports = __webpack_public_path__ + "img/plan-b-other-mobile.9ac7a811.png";